import * as React from 'react';
import SvgIcon from 'material-ui/SvgIcon';
import omit from 'lodash/omit';

const style = {
  height: 32,
  width: 32,
};

const pathStyle = {
  fill: '#757575',
  fillRule: 'evenodd',
};

const XIcon = (props: any) => {
  const other = omit(props, ['style', 'pathStyle']);

  return (
    <SvgIcon viewBox="-7.5 -7.5 24 24" style={Object.assign({}, style, props.style)} {...other}>
      <path
        style={Object.assign({}, pathStyle, props.pathStyle)}
        d="M712.1,356.125l-0.972.972,3.4,3.4-3.4,3.4,0.972,0.972,3.4-3.4,3.4,3.4,0.972-.972-3.4-3.4,3.4-3.4-0.972-.972-3.4,3.4Z"
        transform="translate(-711.125 -356.125)"
      />
    </SvgIcon>
  );
};

export default XIcon;
